import { createRoot, Root } from "react-dom/client";
import styles from "./generated.css?inline";
import AiSearchComponent from "./ai-search";

class AiSearchWebComponent extends HTMLElement {
  shadow: ShadowRoot;
  private root: Root | null = null;

  static get observedAttributes() {
    return ["theme"];
  }

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    const mountPoint = document.createElement("div");
    const theme = (this.getAttribute("theme") as "dark" | "light") || "dark";
    
    mountPoint.className = "ai-search-root";
    
    // Aplica a classe de tema no host element para que as variáveis CSS funcionem
    if (theme === "dark") {
      this.classList.add("dark");
    } else {
      this.classList.remove("dark");
    }

    this.injectTailwindStyles(styles);
    this.shadow.appendChild(mountPoint);

    this.root = createRoot(mountPoint);
    this.renderComponent();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === "theme" && oldValue !== newValue) {
      this.updateTheme(newValue as "dark" | "light");
      if (this.root) {
        this.renderComponent();
      }
    }
  }

  private updateTheme(theme: "dark" | "light") {
    if (theme === "dark") {
      this.classList.add("dark");
    } else {
      this.classList.remove("dark");
    }
  }

  private renderComponent() {
    if (!this.root) return;
    
    const theme = (this.getAttribute("theme") as "dark" | "light") || "dark";
    
    this.root.render(
      <AiSearchComponent
        organizationId={this.getAttribute("organization-id") || ""}
        publicKey={this.getAttribute("public-key") || ""}
        theme={theme}
        placeholder={this.getAttribute("placeholder") || undefined}
      />
    );
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }

  /**
   * Injeta o CSS do Tailwind no Shadow DOM e move os @property para o document.head
   */
  private injectTailwindStyles(css: string) {
    this.injectAtPropertiesToHead(css);

    if ("adoptedStyleSheets" in Document.prototype && typeof CSSStyleSheet !== "undefined") {
      try {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        this.shadow.adoptedStyleSheets = [sheet];
        return;
      } catch (err) {
        console.warn("adoptedStyleSheets não suportado, usando fallback <style>", err);
      }
    }

    const styleTag = document.createElement("style");
    styleTag.textContent = css;
    this.shadow.appendChild(styleTag);
  }

  /**
   * Move blocos @property (como --tw-border-style) do CSS do Tailwind para o document.head
   */
  private injectAtPropertiesToHead(css: string) {
    const propertyBlocks = css.match(/@property\s+[^{]+\{[^}]+\}/g);
    if (propertyBlocks?.length) {
      const style = document.createElement("style");
      style.setAttribute("data-tw-properties", "true");
      style.textContent = propertyBlocks.join("\n");
      document.head.appendChild(style);
    }
  }
}

customElements.define("ai-search", AiSearchWebComponent);
export default AiSearchWebComponent;
